<template>
  <ion-page>
    <master-layout @refreshPage="reRender" pageTitle="ویرایش کاتالوگ ها">
      <Loading v-if="!loaded"></Loading>
      <div v-if="loaded">
        <ion-card-content v-if="catalog">
            <div class="form-group">
              <div>مشتری : {{customer.fullname}}</div>
<!--              <AliAjaxSelect class="mb-1" route="getCustomerForSelect"-->
<!--                             :selected="(customer?[customer]:[])"-->
<!--                             :on-change="changeUser"-->
<!--                               title="نام / شماره تلفن مشتری (بدون صفر)" itemTitle="fullname" name="fullname"-->
<!--                               desc="جستجو نام مشتری" itemId="_id"></AliAjaxSelect>-->
              <div class="d-flex-between">
                <div class="product_div"><AliAjaxSelect :on-change="changeProduct" route="app/GetProductForSelect" class="product_select"
                                    title="نام محصول" itemTitle="title" name="product_id"
                                    desc="جستجو محصول" itemId="_id"
                ></AliAjaxSelect></div>
                <div>
                  <button @click="addProductToList()" type="button" class="btn btn-info"><i class="far fa-plus"></i></button>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-striped center">
                <thead>
                <tr>
                  <th>#</th>
                  <th>محصول</th>
                  <th>حذف</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(p,index) in products" :key="index">
                  <td>{{(index+1)}}</td>
                  <td>{{p.title}}</td>
                  <td><i @click="removeProduct(index)" class="far fa-trash-alt fa-2x text-danger"></i></td>
                </tr>
                </tbody>
              </table>
            </div>
          <div class="gap-div"></div>
        </ion-card-content>
        <div v-if="error" class="alert alert-danger">
          {{error}}
        </div>
      </div>
    </master-layout>
    <button v-if="loaded && catalog" @click="submitCatalog()" class="btn btn-info btn-block submit_btn" ref="submit_btn">ویرایش کاتالوگ</button>
  </ion-page>
</template>

<script>
import {
  IonCardContent, IonPage
} from "@ionic/vue";
// import AjaxForm from "../components/AjaxForm";
import AliAjaxSelect from "../components/aliAjaxSelect";
import {showSystemNoti} from "../shared/helper";
import {mapActions} from "vuex";
import Loading from "../components/Loading";

export default {
  data()
  {
    return {
      loaded : false,
      customer : null,
      products : [],
      product : null,
      catalog : null,
      error : null,
      id : null,
    };
  },
  async mounted()
  {
    await this.init();
  },
  methods:{
    reRender()
    {
      this.init();
    },
    ...mapActions('app',{
      editCatalog : 'editCatalogInfo',
      getCatalogInfo : 'getCatalogInfo',
    }),
    async init()
    {
      this.loaded = false;
      this.id = this.$route.params.id;
      this.catalog = null;
      this.customer = null;
      this.products = [];
      const check = await this.getCatalogInfo(this.id);
      this.loaded = true;
      if (check)
      {
        if (check.ok)
        {
          this.catalog = check.catalog;
          this.products = this.catalog.products;
          this.customer = this.catalog.user;
        }
        else
          this.error = check.error;
      }
      else
        this.error = 'خطا در برقراری ارتباط با سرور.'

    },
    changeProduct(p)
    {
      if (p && p[0])
      {
        this.product = p[0];
      }
      else
        this.product = null;
    },
    changeUser(p)
    {
      if (p && p[0])
      {
        this.customer = p[0];
      }
      else
        this.customer = null;
    },
    addProductToList()
    {
      const p = this.product;
      const products = JSON.parse(JSON.stringify(this.products));
      if (p)
      {
        products.push(p);
        const uniqueValues = new Set(products.map(v => v._id));
        if (uniqueValues.size === products.length)
          this.products.push(p);
        else
          return showSystemNoti('danger','محصول تکراری می باشد.');
      }
    },
    removeProduct(index)
    {
      this.products.splice(index,1);
    },
    async submitCatalog()
    {

      const products = this.products;
      if (!products.length)
        return showSystemNoti('danger','کاتالوگ حداقل باید یک محصول داشته باشد.');
      let final_product_ids = [];
      for (let i = 0; i < products.length; i++)
        final_product_ids.push(products[i]._id);
      const btn = this.$refs['submit_btn'];
      btn.setAttribute('disabled',true);
      const html = btn.innerHTML;
      btn.innerHTML = '<i class="far fa-spinner fa-pulse"></i>';
      const result = await this.editCatalog(
          {id : this.id,product_ids: final_product_ids});
      btn.innerHTML = html;
      btn.removeAttribute('disabled');
      if (result)
      {
        if (result.ok)
        {
          showSystemNoti('success',result.message);
        }
        else
          return showSystemNoti('danger',result.error);
      }
      else
        return showSystemNoti('danger','خطا در برقراری ارتباط با سرور.');


    }

  },
  components: {
    Loading,
    // AjaxForm,
   IonCardContent, IonPage,AliAjaxSelect
  }
};
</script>

<style scoped>
.d-flex-between
{
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
}
.product_div
{
  width: 80%!important;
}
.submit_btn {
  position: absolute;
  bottom: 57px;
  width: 100%;
}
.gap-div
{
  width: 100%;
  height: 57px;
}
.mb-1
{
  margin-bottom: 5px;
}
</style>